"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const opexs_1 = require("@/store/ducks/opexs");
const opexs_2 = require("@/services/opexs");
const listOpexsUseCase_1 = __importDefault(require("./listOpexsUseCase"));
function createOpexUseCase(payload) {
    return (dispatch) => {
        dispatch((0, opexs_1.startSaveOpexReducer)());
        return (0, opexs_2.createOpexService)(payload)
            .then(async () => {
            dispatch((0, opexs_1.saveOpexSuccessReducer)());
            await (0, listOpexsUseCase_1.default)()(dispatch);
            // dispatch(
            //   openSystemToast({
            //     status: "success",
            //     message: "System created successfully",
            //   })
            // );
        })
            .catch(() => {
            dispatch((0, opexs_1.saveOpexErrorReducer)());
            // dispatch(
            //   openSystemToast({
            //     status: "error",
            //     message: "Error creating system",
            //   })
            // );
        });
    };
}
exports.default = createOpexUseCase;
